import React from 'react'
import { Modal } from 'rsuite';
import { ALLOWED_PRICE_SKUS } from '../../utils/constants';
import { MdErrorOutline } from "react-icons/md";

interface MoreInfoModalProps {
    isMoreInfo: boolean;
    setIsMoreInfo: (value: boolean) => void;
    moreInfoMessage: { heading: string, message: any };
    type: string
}

const MoreInfoModal = ({ isMoreInfo, setIsMoreInfo, moreInfoMessage, type }: MoreInfoModalProps) => {
    const isArrayMessage = Array.isArray(moreInfoMessage?.message);

    return (
        <div>
            <Modal
                className="more-info-modal w-[40vw] h-[40vh]"
                open={isMoreInfo}
                onClose={() => setIsMoreInfo(false)}
                backdrop="static"
                keyboard={false}

            >
                <Modal.Header className={`${type === 'error' ? "bg-red-600" : type === 'warning' ? "bg-[#f1a706]" : "bg-white"} p-4 m-0`}>
                    <Modal.Title className="font-normal text-[1.05vw] text-white">
                        {moreInfoMessage?.heading}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ padding: "0 20px" }}>
                    {isArrayMessage ? (
                        <div>
                            {moreInfoMessage?.message?.map((item: any, idx: number) => {
                                // DRY: handle both structured and unstructured array messages
                                if (
                                    item &&
                                    typeof item === 'object' &&
                                    'key' in item &&
                                    Array.isArray(item.missing)
                                ) {
                                    return (
                                        <div key={item.key} style={{ marginBottom: '1em' }}>
                                            <span style={{ fontWeight: 'bold' }}>{item.key}:</span>
                                            <div style={{ marginLeft: 8 }}>
                                                {item.missing.map((miss: any, i: number) => (
                                                    <div key={i}>{miss}</div>
                                                ))}
                                            </div>
                                        </div>
                                    );
                                } else {
                                    // Fallback: just print the item as a string
                                    return (
                                        <div key={idx} style={{ marginBottom: '1em' }}>
                                            {typeof item === 'string' ? item : JSON.stringify(item)}
                                        </div>
                                    );
                                }
                            })}
                        </div>
                    ) : (
                        moreInfoMessage.message
                    )}
                </Modal.Body>
                <Modal.Footer style={{ padding: "20px" }}>
                    {ALLOWED_PRICE_SKUS && ALLOWED_PRICE_SKUS.length > 0 && (
                        <div
                            style={{
                                fontSize: '0.95em',
                                marginTop: 8,
                                textAlign: 'left',      // Ensures text is left-aligned
                                justifyContent: 'flex-start', // For flex containers
                                display: 'block'        // Ensures block layout
                            }}
                        >
                            <strong>Allowed PRICE_SKUs:</strong>
                            <ul style={{ margin: 0, paddingLeft: 18 }}>
                                {ALLOWED_PRICE_SKUS.map((sku: string) => (
                                    <li key={sku}>{sku}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                </Modal.Footer>
            </Modal>
        </div >
    )
}

export default MoreInfoModal